export const EXTERNAL_REFERENCE_SOURCE = 'brapi-sync';
export const BRAPI_SYNC_BASE_URL_PLACEHOLDER = 'https://<host>/bmsapi/<cropname>/brapi/v2';
